import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleOpthalmology from '../../schemas/module-opthalmology.json';

export class SchemaModuleOpthalmology extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleOpthalmology );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-opthalmology.ts